import { inject, Service } from "@angular/core";

import { ItemDs3Progress, MainResponseModel } from "../models";
import { MainService } from ".";

@Service()
export class ProgressApiService {
  private _mainService = inject(MainService);

  public getProgress({
    itemId,
    itemType,
    periodId,
    year,
  }: {
    itemId: number;
    itemType: number;
    periodId?: number;
    year?: number;
  }) {
    const qs = new URLSearchParams({
      itemId: `${itemId}`,
      itemType: `${itemType}`,
    });

    if (periodId) qs.set("periodId", `${periodId}`);
    if (year) qs.set("year", `${year}`);

    return this._mainService.sendRequest<MainResponseModel<ItemDs3Progress>>({
      method: "GET",
      url: `progress/get?${qs.toString()}`,
    });
  }

  public getProgressList({ itemId, itemType }: { itemId: number; itemType: number }) {
    const qs = new URLSearchParams({
      itemId: `${itemId}`,
      itemType: `${itemType}`,
    });

    return this._mainService.sendRequest<MainResponseModel<ItemDs3Progress[]>>({
      method: "GET",
      url: `progress/list?${qs.toString()}`,
    });
  }
}
